import { render, staticRenderFns } from "./checkEditorHeartLung.vue?vue&type=template&id=52d0e57b&scoped=true&"
import script from "./checkEditorHeartLung.vue?vue&type=script&lang=js&"
export * from "./checkEditorHeartLung.vue?vue&type=script&lang=js&"
import style0 from "./checkEditorHeartLung.vue?vue&type=style&index=0&id=52d0e57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0e57b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d0e57b')) {
      api.createRecord('52d0e57b', component.options)
    } else {
      api.reload('52d0e57b', component.options)
    }
    module.hot.accept("./checkEditorHeartLung.vue?vue&type=template&id=52d0e57b&scoped=true&", function () {
      api.rerender('52d0e57b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkEditorHeartLung.vue"
export default component.exports